import { Formik } from "formik";
import { useTranslation } from "react-i18next";
import { PlantaTratamientoSchema } from "../data/PlantaTratamientoSchema";
import Grid from "./layout/Grid";
import Panel from "./layout/Panel";
import Row from "./layout/Row";
import Col from "./layout/Col";
import Label from "./controls/Label";
import TextField from "./controls/TextField";
import { isInvalid } from "../utils/forms";
import QuestionField from "./controls/QuestionField";
import TextareaField from "./controls/TextareaField";
import ArrayField from "./controls/ArrayField";

import Pagination from "./controls/Pagination";
import Button from "./controls/Button";

import { TecnologiaTratamientoForm } from "./TecnologiaTratamientoForm";
import { filtrarTecnologias } from "../utils/data";

export function PlantaTratamientoForm({
  value,
  page,
  pages,
  select,
  append,
  replace,
  remove,
  tecnologias,
  disabled,
}) {
  const { t } = useTranslation();
  const handleNombreChange = (form) => (event) => {
    form.handleChange(event);
  };
  const handleConManualOperacion = (form) => (event) => {
    form.handleChange(event);
  };
  const handleConPlanMantenimiento = (form) => (event) => {
    form.handleChange(event);
  };
  const handleDescripcion = (form) => (event) => {
    form.handleChange(event);
  };
  const handleTecnologias = (form) => (event) => {
    form.handleChange(event);
  };
  return (
    <Formik
      initialValues={value}
      enableReinitialize={true}
      validateOnChange={true}
      validationSchema={PlantaTratamientoSchema}
      onSubmit={(values) => {
        if (page === -1) {
          append(values);
        } else {
          replace(values, page);
        }
      }}
    >
      {(form) => (
        <Grid as={<Panel />} className="formulario embebido">
          <Row>
            <Col>
              <Label>{t("plantaTratamientoForm.titulo")}</Label>
            </Col>
          </Row>
          <Row>
            <Col>
              <TextField
                id="plantaTratamiento_nombre"
                name="nombre"
                label={t("plantaTratamiento.nombre")}
                value={form.values.nombre}
                onChange={handleNombreChange(form)}
                isInvalid={isInvalid("nombre", form)}
                error={t(form.errors.nombre)}
                disabled={disabled}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <QuestionField
                id="plantaTratamiento_conManualOperacion"
                name="conManualOperacion"
                label={t("plantaTratamiento.conManualOperacion")}
                value={form.values.conManualOperacion}
                onChange={handleConManualOperacion(form)}
                isInvalid={isInvalid("conManualOperacion", form)}
                error={t(form.errors.conManualOperacion)}
                disabled={disabled}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <QuestionField
                id="plantaTratamiento_conPlanMantenimiento"
                name="conPlanMantenimiento"
                label={t("plantaTratamiento.conPlanMantenimiento")}
                value={form.values.conPlanMantenimiento}
                onChange={handleConPlanMantenimiento(form)}
                isInvalid={isInvalid("conPlanMantenimiento", form)}
                error={t(form.errors.conPlanMantenimiento)}
                disabled={disabled}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <TextareaField
                id="plantaTratamiento_descripcion"
                name="descripcion"
                label={t("plantaTratamiento.descripcion")}
                value={form.values.descripcion}
                onChange={handleDescripcion(form)}
                rows={12}
                isInvalid={isInvalid("descripcion", form)}
                error={t(form.errors.descripcion)}
                disabled={disabled}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <Label>{t("plantaTratamiento.tecnologias")}</Label>
              <ArrayField
                id="plantaTratamiento_tecnologias"
                name="tecnologias"
                value={form.values.tecnologias}
                onChange={handleTecnologias(form)}
                isInvalid={isInvalid("tecnologias", form)}
                error={t(form.errors.tecnologias)}
                disabled={disabled}
              >
                {({ value, append, remove, disabled }) => (
                  <TecnologiaTratamientoForm
                    value={value}
                    append={append}
                    remove={remove}
                    tecnologias={filtrarTecnologias(
                      tecnologias,
                      form.values.tecnologias,
                    )}
                    disabled={disabled}
                  />
                )}
              </ArrayField>
            </Col>
          </Row>
          <Row style={{ display: "flex", flexWrap: "wrap" }}>
            <Col lg={6}>
              <Pagination
                sm
                page={page}
                pages={pages}
                onChange={(event) => select(event.target.value)}
              />
            </Col>
            <Col lg={6}>
              <span
                style={{
                  float: "right",
                  alignContent: "center",
                }}
              >
                {page !== -1 && (
                  <Button
                    sm
                    variant="success"
                    value={t("plantaTratamientoForm.nuevo")}
                    onClick={(event) => {
                      event.preventDefault();
                      select(-1);
                    }}
                    disabled={disabled}
                  />
                )}
                {page !== -1 && (
                  <Button
                    sm
                    variant="danger"
                    value={t("plantaTratamientoForm.eliminar")}
                    onClick={(event) => {
                      event.preventDefault();
                      remove(page);
                    }}
                    disabled={disabled}
                  />
                )}
                <Button
                  sm
                  variant="primary"
                  value={t("plantaTratamientoForm.guardar")}
                  onClick={(event) => {
                    event.preventDefault();
                    form.submitForm();
                  }}
                  disabled={disabled}
                />
                {page === -1 && pages > 0 && (
                  <Button
                    sm
                    variant="default"
                    value={t("plantaTratamientoForm.cancelar")}
                    onClick={(event) => {
                      event.preventDefault();
                      select(0);
                    }}
                    disabled={disabled}
                  />
                )}
              </span>
            </Col>
          </Row>
        </Grid>
      )}
    </Formik>
  );
}
